export default __webpack_public_path__ + "static/freedom-offer-c85a4d43908bfddb056f1c8fd35dc6dc.png";